import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ErrorService } from 'src/app/core/services/error.service';
import { MatLuxonDateModule, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { castToDateAttribute } from 'src/app/shared/functions/date.functions';

export const MY_FORMATS = {
  parse: {
    dateInput: 'yyyy-LL-dd',
  },
  display: {
    dateInput: 'dd/LL/yyyy',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-input-date',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatLuxonDateModule,
  ],
  providers: [
    MatDatepickerModule,
    provideLuxonDateAdapter(MY_FORMATS)
  ],
  templateUrl: './input-date.component.html',
  styleUrl: './input-date.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputDateComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() class: string = '';
  @Input({
    transform: castToDateAttribute,
  }) minDate?: Date;
  @Input({
    transform: castToDateAttribute,
  }) maxDate?: Date;
  @Input() labelError?: string;

  constructor(
    private errorService: ErrorService
  ) {}

  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.labelError ?? this.label ?? this.name, errors);
  }

}
